import { Box, Card, CardContent, Typography } from "@mui/material";

export default function TeamPricingInfoCard() {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "16px",
        border: "1px solid #E2E8F0",
        bgcolor: "#DBEAFE",
        gridColumn: { xs: "1", md: "1 / -1" },
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Typography
          variant="subtitle2"
          className="font-semibold text-blue-900 mb-2"
        >
          Team Pricing Information
        </Typography>
        <Box className="space-y-1">
          <Typography variant="body2" className="text-blue-800">
            Team seats are billed monthly per active user.
          </Typography>
          <Typography variant="body2" className="text-blue-800">
            Proration applies when seats are added or removed mid-cycle.
          </Typography>
          <Typography variant="body2" className="text-blue-800">
            Inactive seats are automatically disabled after 30 days of
            inactivity.
          </Typography>
          <Typography variant="body2" className="text-blue-800">
            Team admins can manage seat assignments in their dashboard.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}
